import { type ReactElement } from 'react';
import { Result } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

export const DefaultPage = (): ReactElement => {
  return (
    <Result
      icon={
        <ArrowLeftOutlined
          style={{ fontSize: '36px', color: 'var(--color-icon)' }}
        />
      }
      title="Welcome to Aidentified Admin"
      subTitle="Please select a menu option from the left side to get started."
    />
  );
};
